module.exports = __webpack_public_path__ + "img/address_big.e9ae7d4b.png";